<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">发票查询</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入发票抬头"
                v-model="searchForm.title"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入纳税人识别号"
                v-model="searchForm.taxpayer_number"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入发票编号"
                v-model="searchForm.invoice_no"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入物流编号"
                v-model="searchForm.logistics_no"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="请选择开票状态"
                element-id="ordertype"
                v-model="searchForm.invoice_state"
              >
                <Option
                  v-for="spareType in invoiceState"
                  :key="spareType.id"
                  :value="spareType.id"
                >
                  {{ spareType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择申请开票时间'"
                :value="emptyOrderTime"
                @on-change="
                  daterangeOrderChange(
                    $event,
                    'apply_start_time',
                    'apply_end_time'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                :placeholder="'请选择开票时间'"
                :value="emptyOpenTime"
                @on-change="
                  daterangeOpenChange(
                    $event,
                    'invoice_start_time',
                    'invoice_end_time'
                  )
                "
              />
            </div>
            <div class="search-detail-item">
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
              <FilterColumn
                :column="allColumns"
                @columnsChecked="columnsChecked = $event"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 工单列表 -->
      <div class="table">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
      <PicsModal
        :pics="picList"
        :visible="picModel"
        :index="picIndex"
        @on-close="picModel = false"
      />
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'
import PicsModal from '@/components/PicsModal'

export default {
  components: {
    DateRangePicker,
    PicsModal,
  },
  data() {
    return {
      columnsChecked: [],
      urlImg: '',
      picModel: false,
      picList: [],
      picIndex: 0,
      emptyOrderTime: ['', ''],
      emptyOpenTime: ['', ''],
      palyName: '',
      busType: '',
      buyPeople: '',
      corpid: '',
      BUYButton: 0,
      editModal: false, // 购买弹窗
      planId: 1,
      editTitle: '购买',
      type: 1,
      editReportCurstom: false, // 报备客户
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        title: '',
        taxpayer_number: '',
        invoice_no: '',
        logistics_no: '',
        invoice_state: '',
        apply_start_time: '',
        apply_end_time: '',
        invoice_start_time: '',
        invoice_end_time: '',
      },
      invoiceState: [
        {
          id: '-1',
          name: '全选',
        },
        {
          id: '1',
          name: '未开票',
        },
        {
          id: '2',
          name: '已开票',
        },
      ],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    allColumns() {
      const allColumns = [
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h(
              'Button',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'AgInvoiceDetail',
                      params: { orderId: row.id },
                    })
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['查看详情']
            )
            // let reEdit = h('Button', {
            //   props: {
            //     type: 'ghost',
            //     size: 'small'
            //   },
            //   on: {
            //     click: () => {
            //       this.typeone = row.type
            //       this.editModal = true
            //       if (row.type === 1) {
            //         this.editTitle = '购买'
            //       } else if (row.type === 2) {
            //         this.editTitle = '升级'
            //       } else {
            //         this.editTitle = '续费'
            //       }
            //     }
            //   }
            // }, ['重新编辑'])
            return h('span', [check])
          },
        },
        {
          title: '申请时间',
          key: 'create_time',
          width: 180,
          ellipsis: true,
        },
        {
          title: '发票金额',
          key: 'order_total_amount',
          width: 140,
        },
        {
          title: '发票抬头',
          key: 'title',
          width: 140,
          ellipsis: true,
        },
        {
          title: '开票状态',
          key: 'invoice_state',
          width: 100,
          render: (h, { row }) => {
            let Type = ''
            if (row.invoice_state === 1) {
              Type = '开票中'
            } else if (row.invoice_state === 2) {
              Type = '已开票'
            }
            return h('span', [Type])
          },
        },
        {
          title: '开票时间',
          key: 'invoice_time',
          width: 140,
          render: (h, { row }) => {
            let invoiceTime = ''
            if (row.invoice_state === 2) {
              invoiceTime = row.invoice_time
            } else {
              invoiceTime = '-'
            }
            return h('span', [invoiceTime])
          },
        },
        {
          title: '税务编号',
          key: 'invoice_no',
          width: 180,
          render: (h, { row }) => {
            let invoiceNo = ''
            if (row.invoice_state === 2) {
              invoiceNo = row.invoice_no
            } else {
              invoiceNo = '-'
            }
            return h('span', [invoiceNo])
          },
        },
        {
          title: '物流编号',
          key: 'logistics_no',
          width: 180,
          render: (h, { row }) => {
            let logisticsNo = ''
            if (row.invoice_state === 2) {
              logisticsNo = row.logistics_no
            } else {
              logisticsNo = '-'
            }
            return h('span', [logisticsNo])
          },
        },
        {
          title: '开票凭证',
          key: 'img_urls',
          width: 140,
          render: (h, { row }) => {
            let check = h(
              'a',
              {
                props: {
                  type: 'ghost',
                  size: 'small',
                },
                on: {
                  click: () => {
                    this.picIndex = this.index
                    this.picModel = true
                    this.urlImg = row.img_urls
                    this.showPicList(row.id)
                  },
                },
                style: {
                  marginLeft: '10px',
                },
              },
              ['查看图片']
            )
            if (row.invoice_state === 2) {
              return h('span', [check])
            } else {
              return h('span', ['-'])
            }
          },
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return allColumns
    },
    columns() {
      const allColumns = this.allColumns
      let arr = allColumns.filter((col) => {
        if (!col.key || !col.key.trim()) {
          return true
        } else {
          if (this.columnsChecked.length) {
            return this.columnsChecked.includes(col.key)
          } else {
            return true
          }
        }
      })
      if (this.columnsChecked.length) {
        let indexMap = this.columnsChecked.reduce((p, c, i) => {
          p[c] = i
          return p
        }, {})
        let left = arr.filter((col) => this.columnsChecked.includes(col.key))
        let right = arr.filter((col) => !this.columnsChecked.includes(col.key))
        arr = left
          .sort((p, c) => indexMap[p.key] - indexMap[c.key])
          .concat(right)
      }
      return arr
    },
  },
  methods: {
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/invoice/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/invoice/count', {
            params: this.searchForm,
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeOrderChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyOrderTime = [this.searchForm[start], this.searchForm[end]]
    },
    daterangeOpenChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyOpenTime = [this.searchForm[start], this.searchForm[end]]
    },
    // 查看图片
    showPicList(index) {
      let arrImg = this.urlImg
      let arr = arrImg.split(',')
      console.log(arr)
      if (arr.length !== 0) {
        arr.forEach((item) => {
          this.picList.push(item)
        })
      }
      this.picIndex = index
      this.picModel = true
    },
    // 重置搜索框
    resetSearchForm() {
      this.emptyOrderTime = ['', '']
      this.emptyOpenTime = ['', '']
      this.searchForm = {
        title: '',
        taxpayer_number: '',
        invoice_no: '',
        logistics_no: '',
        invoice_state: '',
        apply_start_time: '',
        apply_end_time: '',
        invoice_start_time: '',
        invoice_end_time: '',
      }
      this.loadList()
    },
    editReport() {
      this.editReportCurstom = true
    },
  },
  created() {
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    height: 80px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/invoiceSearch/index.vue